import styled, { css } from 'styled-components';
import { Ellipsis } from '@simplywallst/ui-core';

export const Wrapper = styled('ul')`
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  text-align: left;
  background: ${({ theme }) => theme.color.charcoal};
`;

export const SkeletonLink = styled('div')``;

interface CardProps {
  outline?: boolean;
}

export const Card = styled('li')<CardProps>`
  display: inline-block;
  vertical-align: top;
  ${({ theme }) => css`
    margin: ${theme.x1spacePx}px ${theme.x1spacePx / 2}px;
  `}
  > div {
    background: ${({ theme }) => theme.color.whiteRGBA(0.05)};
    white-space: wrap;
  }
  > a,
  > button,
  > ${SkeletonLink} {
    display: block;
    position: relative;
    ${({ theme, outline }) => css`
      padding: ${theme.x1spacePx}px;
      width: ${theme.x20spacePx}px;
      height: ${theme.x11spacePx}px;
      background: ${outline ? 'none' : theme.color.whiteRGBA(0.05)};
      box-shadow: ${outline
        ? `inset 0 0px 1px 1px ${theme.color.whiteRGBA(0.1)}`
        : `none`};
      border-radius: ${theme.x1spacePx / 2}px;
    `}
  }
  &:last-child {
    margin-right: ${({ theme }) => theme.x1spacePx}px;
  }
  &:first-child {
    margin-left: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const ButtonLink = styled('button')`
  display: block;
  width: 100%;
  text-align: left;
`;

export const BoneWrapper = styled('i')`
  padding: 2px 0;
  display: block;
  height: ${({ theme }) => theme.x2spacePx}px;
  > span {
    height: 12px;
  }
`;

export const Details = styled('div')`
  position: absolute;
  top: ${({ theme }) => theme.x1spacePx}px;
  left: ${({ theme }) => theme.x1spacePx}px;
  right: ${({ theme }) => theme.x1spacePx}px;
`;

export const Name = styled('h2')`
  ${({ theme }) => theme.typography.smallStrong};
  color: ${({ theme }) => theme.color.white};
  margin: 0;
  margin-top: -2px;
  margin-bottom: ${({ theme }) => theme.x1spacePx / 4}px;
  ${Ellipsis}
  + ${BoneWrapper} > span {
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  }
`;

export const Summary = styled('p')`
  ${({ theme }) => theme.typography.tiny};
  color: ${({ theme }) => theme.color.white};
  opacity: 0.5;
  margin: 0;
`;

export const Returns = styled('ul')`
  position: absolute;
  bottom: ${({ theme }) => theme.x1spacePx / 2}px;
  left: ${({ theme }) => theme.x1spacePx}px;
  width: 100%;
  li {
    display: inline-block;
    color: ${({ theme }) => theme.color.white};
    min-width: ${({ theme }) => theme.x5spacePx}px;
    &:first-child {
      margin-right: ${({ theme }) => theme.x1spacePx}px;
    }
  }
  i {
    height: 19px;
    padding: 3px 0 4px;
  }
  span {
    display: block;
    &:first-child {
      opacity: 0.3;
      ${({ theme }) => theme.typography.tinyStrong};
      margin-bottom: -4px;
    }
    &:last-child {
      ${({ theme }) => theme.typography.xSmall};
    }
  }
`;
